/**
 * Copyright (c) 2025 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Eugen Becker <e.becker@techdivision.com>
 */

import React, { useState, useRef } from 'react';
import { Info } from './Info';

export const Tooltip = ({ text, children }) => {
  const childrenRef = useRef(document.createElement('div'));
  const [isVisible, setIsVisible] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  /**
   *
   * @param {MouseEvent<HTMLDivElement>} event
   */
  const show = (event) => {
    const { clientX, clientY } = event;
    const isMobile = window.innerWidth <= 768;
    const left = isMobile ? 0 : (childrenRef.current.offsetWidth + 24);
    setCoords({ x: left, y: -12 });
    setIsVisible(true);
  };

  return (
    <div className="tooltip-wrapper" tabIndex={0}>
      {isVisible && (
        <div className="tooltip-box" style={{
          left: coords.x,
          top: coords.y,
        }}>
          {text}
        </div>
      )}
      <div className="tooltip-content">
        <div className="tooltip-children" ref={childrenRef}>
          {children}
        </div>
        <div className="tooltip-trigger"
             onMouseEnter={show}
             onMouseLeave={() => setIsVisible(false)}
             onFocus={show}
             onBlur={() => setIsVisible(false)}>
          <Info />
        </div>
      </div>
    </div>
  );
};
